import { render, staticRenderFns } from "./VUploadImgList.vue?vue&type=template&id=465a65f8&"
import script from "./VUploadImgList.vue?vue&type=script&lang=js&"
export * from "./VUploadImgList.vue?vue&type=script&lang=js&"
import style0 from "./VUploadImgList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports